<template>
  <VProgressLinear :aria-label="t('loading')" />
</template>

<script setup lang="ts">
import { useAuth } from '@/composables/useAuth';
import { useAxleAuth } from '@/composables/useAxleAuth';
import { useDeepLink } from '@/composables/useDeepLink';
import { isAuthenticated } from '@/stores/authStore';
import { onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n();
const router = useRouter();
const { logOut } = useAuth();
const { token, hasDeepLinkIntent, resolveDeepLink } = useDeepLink();

const {
  axleTokenRequest,
  logInAxle,
} = useAxleAuth({
  onLogInSuccess,
  onLogInError,
});

function onLogInSuccess() {
  if (!hasDeepLinkIntent) {
    // router.beforeEach will redirect to UnauthenticatedView if session was not established
    router.replace({ name: 'TeamBudgets' });
  }
  // deep-link: handleDeepLink handles its own navigation after logInAxle resolves
}

function onLogInError() {
  // router.beforeEach will redirect to UnauthenticatedView
  router.replace({ path: '/' });
}

async function logIn() {
  await logOut();
  if (!token) {
    onLogInError();
    return;
  }
  axleTokenRequest.token = token;
  await logInAxle();
}

async function handleDeepLink() {
  if (isAuthenticated()) {
    // keep existing session — skip logout and token exchange
  } else if (token) {
    await logOut();
    axleTokenRequest.token = token;
    await logInAxle();
    // logInAxle swallows errors internally and calls onLogInError on failure;
    // check auth state to avoid continuing into resolveDeepLink with no session
    if (!isAuthenticated()) return;
  } else {
    onLogInError();
    return;
  }

  const destination = await resolveDeepLink();
  router.replace(destination);
}

onBeforeMount(hasDeepLinkIntent ? handleDeepLink : logIn);
</script>
